import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { TaxReturnForLeasingPropCoRuleset } from '../../business/ruleset';
import { RulesetResult } from '../../business/rules';

const {
  companyDocuments: { taxReturnForLeasingPropCo },
} = loanFormModel.formField;

export class PgMortgageStatementValidation implements ValidationSchema {
  public name = taxReturnForLeasingPropCo.name;
  public label = '';
  public type = 'mixed';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = TaxReturnForLeasingPropCoRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    schema = FileNameValidationSchema(taxReturnForLeasingPropCo.name, required);
    if (required) schema = schema.required('This document is required');

    return schema;
  }
}
export default new Validation(new PgMortgageStatementValidation());
